const DESCRIPTION_MAX_CHARS = 1000

export type UploadDescriptionContext =
  | 'storage'
  | 'storage-folder'
  | 'settings-storage'
  | 'editor-image'

type UploadDescriptionFile = Pick<File, 'name' | 'type'>

const CONTEXT_LABELS = {
  storage: 'Storage upload',
  'storage-folder': 'Storage folder upload',
  'settings-storage': 'Settings storage upload',
  'editor-image': 'Editor image attachment',
} satisfies Record<UploadDescriptionContext, string>

function compact(value: string): string {
  return value.replace(/\s+/g, ' ').trim()
}

export function buildUploadDescription(
  file: UploadDescriptionFile,
  context: UploadDescriptionContext,
): string {
  const filename = compact(file.name) || 'unnamed file'
  const contentType = compact(file.type)
  const fileDetails = contentType ? `${filename} (${contentType})` : filename

  return compact(`${CONTEXT_LABELS[context]}: ${fileDetails}`).slice(0, DESCRIPTION_MAX_CHARS)
}

export function appendUploadDescription(
  formData: FormData,
  file: UploadDescriptionFile,
  context: UploadDescriptionContext,
): void {
  formData.append('description', buildUploadDescription(file, context))
}
